/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Priority order for the "request a company check" banner:
 * 1. verified: no unverified entity left
 * 2. incomplete legal information
 * 3. unverified entity (no company identity) and no manual pending request
 * 4. unverified entity (no company identity) and presence of manual pending request
 * 
 * @export
 */
export const OrganizationVerificationStatus = {
    Verified: 'VERIFIED',
    IncompleteInfo: 'INCOMPLETE_INFO',
    NotVerified: 'NOT_VERIFIED',
    Pending: 'PENDING'
} as const;
export type OrganizationVerificationStatus = typeof OrganizationVerificationStatus[keyof typeof OrganizationVerificationStatus];


export function instanceOfOrganizationVerificationStatus(value: any): boolean {
    for (const key in OrganizationVerificationStatus) {
        if (Object.prototype.hasOwnProperty.call(OrganizationVerificationStatus, key)) {
            // @ts-ignore
            if (OrganizationVerificationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrganizationVerificationStatusFromJSON(json: any): OrganizationVerificationStatus {
    return OrganizationVerificationStatusFromJSONTyped(json, false);
}

export function OrganizationVerificationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationVerificationStatus {
    return json as OrganizationVerificationStatus;
}

export function OrganizationVerificationStatusToJSON(value?: OrganizationVerificationStatus | null): any {
    return value as any;
}

